/* eslint-disable @nx/enforce-module-boundaries */
import { FieldConfig, FilterValue } from '@heitown/common-interfaces';
import { Observable } from 'rxjs';

export interface SharedFacadeInterface<T> {
  allEntities$: Observable<T[]>;
  loadedAll$: Observable<boolean>;
  loadPaged: (
    take: number,
    skip: number,
    orderBy?: { [field: string]: 'asc' | 'desc' },
    filters?: FilterValue[],
    join?: string[]
  ) => void;
  loadPagedSuccess: (items: T[]) => void;
  loadPagedFailure: (error: string) => void;
  loadSingle: (id: string) => void;
  delete: (
    id: string,
    notify: boolean,
    goBack: boolean,
    callback?: () => void
  ) => void;
  loadAll: () => void;
  downloadExcel: (
    fileName?: string,
    columns?: FieldConfig[],
    filters?: FilterValue[],
    orderBy?: { [field: string]: 'asc' | 'desc' },
    join?: string[],
    notify?: boolean
  ) => void;
}
